import { gql } from '@apollo/client';

const GET_CURRENT_USER_NOTIFICATIONS = gql`
  query GetCurrentUserNotifications(
    $continuationToken: String
    $limit: Int
    $includeRead: Boolean
  ) {
    currentUserNotifications(
      continuationToken: $continuationToken
      limit: $limit
      includeRead: $includeRead
    ) {
      Notifications {
        Read
        Notification {
          Id
          CreatedAt
          Type
          Icon
          NotificationData
        }
      }
      ContinuationToken
    }
  }
`;

export default GET_CURRENT_USER_NOTIFICATIONS;
